<template>
    <v-app>
        <v-main>
            <router-view />
            <common-footer />
        </v-main>
    </v-app>
</template>

<style>
html {
    touch-action: manipulation;
}
.v-application {
    font-family: "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Meiryo", "sans-serif" !important;
}
.v-main {
    /* background-color: #ddd; */
    background: radial-gradient(white, grey);
}
</style>

<script>
import CommonFooter from "@/components/CommonFooter";

export default {
    name: "App",
    components: {
        CommonFooter,
    },
    data: () => ({
        //
    }),
};
</script>
